import { axios } from "@/plugins/axios";

function getPLZs(plz) {
    return axios.post("?Mode=General&Function=Plz", "plz=" + plz);
}

function getLocations(plz) {
    return axios.post("?Mode=General&Function=Ort", "plz=" + plz);
}

export { getPLZs, getLocations };
